import gql from "graphql-tag";
import Client from "Apolloclient";
import store from "store/store";
import * as types from './studi.types';
import * as actions from './studi.actions';

export function SalvaStudio(name, address, contractId) {


    const newAddress = {...address};
    delete newAddress.isWorkplace;
    delete newAddress.contract;
    delete newAddress.company;
    delete newAddress.__typename;

    const variables = {name, address: newAddress, contractId};

    let query = {
        fetchPolicy: 'no-cache',
        variables: variables,
        mutation: gql`,
            mutation create (
            $name: String
            $address: AddressInput
            $contractId: String
        ) {
            createdObject: createStudy (
                name: $name,
                address: $address,
                contractId: $contractId,
            ) {
                id
                name
                address {
                    id
                    description
                }
                contract {
                    id
                    description
                    startDate
                    endDate
                    company
                } 
            }
        }
        `
    };

    return Client
        .mutate(query)
        .then(async (response) => {
            var data = response.data.createdObject;

            if (process.env.NODE_ENV === 'development') {
                data = JSON.parse(JSON.stringify(data));
            }

            store.dispatch(actions.created(data));

            return {
                hasError: false
            }
        })
        .catch((e) => {
            var message = 'Impossibile creare lo studio';
            console.error(e);

            if (e.graphQLErrors && e.graphQLErrors.length > 0) {
                message = e.graphQLErrors[0].message;
            }

            return {
                hasError: true,
                message: message
            };
        });
}

export function OttieniStudi() {

    store.dispatch({
        type: types.REQUEST_READ_ALL
    })

    var variables = {};

    let query = {
        fetchPolicy: 'network-only',
        variables: variables,
        query: gql`,
     {
            objectList: studies {
                id
                name
                address {
                    id
                    description
                }
                contract {
                    id
                    description
                }
            }
            }
        `,
    };
    return Client
        .query(query).then(
            async response => {

                var data = response.data.objectList;

                store.dispatch(
                    {
                        type: types.READED_ALL,
                        payload: data
                    }
                );

                return;
            }
        ).catch(
            e => {
                var message = "Impossibile ottenere studio";
                console.error(e);

                if (e.graphQLErrors && e.graphQLErrors.length > 0) {
                    message = e.graphQLErrors[0].message;
                }

                store.dispatch({
                    type: types.READ_ALL_ERROR
                });

                return {
                    hasError: true,
                    message: message
                }
            }
        );
}

export function AggiornaStudio(id, name, address, contractid) {

    // console.log('first Address', address);

    let newAddress = {};
    if (address) {
        newAddress = address;
        delete newAddress.isWorkplace;
        delete newAddress.contract;
        delete newAddress.company;
        delete newAddress.__typename;
    }

    // console.log('Address', newAddress);

    const variables = {id, name, address: newAddress, contractid};

    let query = {
        fetchPolicy: 'no-cache',
        variables: variables,
        mutation: gql`,
        mutation update(
            $id: String!,
            $name: String!
            $address: AddressInput
            $contractid: String

        ){
            updatedObject: updateStudy(
                id: $id,
                name: $name,
                address: $address,
                contractId: $contractid,

            ) {
                id
                name
                address {
                    id
                    description
                }
                contract {
                    description
                    id
                }
            }
        }
        `
    };

    return Client
        .mutate(query)
        .then(async (response) => {
            var data = response.data.updatedObject;

            store.dispatch(actions.updated(data));

            return {
                hasError: false
            }
        })
        .catch((e) => {
            var message = 'Impossibile aggiornare lo studio';
            console.error(e);

            if (e.graphQLErrors && e.graphQLErrors.length > 0) {
                message = e.graphQLErrors[0].message;
            }
            return {
                hasError: true,
                message: message
            }
        });
}

export function EliminaStudio(id) {
    var variables = {id};

    let query = {
        fetchPolicy: 'no-cache',
        variables: variables,
        mutation: gql`,
        mutation (
            $id: String!
        ) {
            deleted: deleteStudy (id: $id) {
                id
            }
        }
        `
    };

    store.dispatch(actions.requestDelete(id));

    return Client
        .mutate(query)
        .then(async (response) => {
            var data = response.data.deleted;

            store.dispatch(actions.deleted(data));

            return {
                hasError: false
            }
        })
        .catch((e) => {
            var message = 'Impossibile eliminare lo studio';
            console.error(e);
            store.dispatch(actions.deleteError(id));


            if (e.graphQLErrors && e.graphQLErrors.length > 0) {
                message = e.graphQLErrors[0].message;
            }

            return {
                hasError: true,
                message: message
            }
        });
}
